import styles from './Button.module.scss.js';
import { ButtonContent } from './ButtonContent.js';
import { jsx } from 'react/jsx-runtime';
import { useLinkSource } from '../link/LinkProvider.js';
import classNames from 'clsx';

function ButtonLink(props) {
  const {
    Link,
    linkProps,
    rest
  } = useLinkSource(props);
  const {
    variant = 'default',
    tag,
    className: callerClassName,
    children,
    size = 'default',
    icon,
    label,
    iconOnly,
    UNSAFE_active,
    UNSAFE_hover,
    UNSAFE_focus,
    ...dataProps
  } = rest;
  const needsTitle = iconOnly || !childIsString(children);
  const title = needsTitle ? childrenToString(children, label) : undefined;
  const className = classNames('dsx-component', styles['no-underline'], styles['button'], styles[`size-${size}`], styles[variant], UNSAFE_active && styles['active'], UNSAFE_hover && styles['hover'], UNSAFE_focus && styles['focus'], callerClassName);
  return /*#__PURE__*/jsx(Link, {
    ...dataProps,
    ...linkProps,
    className: className,
    "data-dsx--link": tag,
    "aria-label": title,
    children: /*#__PURE__*/jsx(ButtonContent, {
      ...props
    })
  });
}
function childIsString(arg) {
  return typeof arg === 'string';
}
function childrenToString(arg, fallback) {
  if (childIsString(arg)) {
    return arg;
  }
  return fallback;
}

export { ButtonLink };
